import * as React from 'react';
import { connect } from 'react-redux';
import { updateHCThemeColorAction } from 'state/actions/help-center/help-center';

export const withSetThemeColorInRedux = <P extends object>(
	InnerComponent: React.ComponentType<P>,
) => {
	const Component = (
		props: P & { bannerBackgroundColor: string; setThemeColor: typeof updateHCThemeColorAction },
	) => {
		const { bannerBackgroundColor, setThemeColor } = props;
		React.useEffect(() => {
			if (bannerBackgroundColor) {
				setThemeColor({
					themeColor: bannerBackgroundColor,
				});
			}
		}, [bannerBackgroundColor, setThemeColor]);

		return <InnerComponent {...props} />;
	};

	return connect(null, {
		setThemeColor: updateHCThemeColorAction,
	})(
		Component as React.FC<{
			bannerBackgroundColor: string;
			setThemeColor: typeof updateHCThemeColorAction;
		}>,
	);
};
